import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import AddPerkForm from "./AddPerkForm";
import Firebase from "../../../firebasehelper";
import { TerritoryOptions } from "../../../Constants/retailer";
// import { allRetailersSelector } from "../../../redux/reducers";
const OfferContent = ({ onChangeContent, offerType, isVisible }) => {
  const location = useLocation();
  const [hot_topic_tags, setHotTopicTags] = useState([]);
  const [retailerOptions, setRetailers] = useState([]);
  const [perkContent, setPerkContent] = useState({});
  const [selectedRetailer, setSelectedRetailer] = useState({});
  const [allRetailers, setAllRetailers] = useState([]);
  // const brand = useSelector((state) => state.brand);
  // const allRetailers = useSelector(allRetailersSelector);
  const { brand } = location.state;
  useEffect(() => {
    if (brand) {
      // add post for brand
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (!brand_data) return;
        console.log("brand", brand, brand_data);
        Firebase.getAllHotTopics(brand_data.name, (hot_topics) => {
          let hot_topic_tags = hot_topics.map((topic) => {
            let label = `${topic.starting_monday
              .toDate()
              .toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
              })} - ${topic.tag}`;
            let value = topic;
            return { label, value };
          });
          setHotTopicTags(hot_topic_tags);
        });
        const brandTerritory = brand_data.territory || TerritoryOptions[0];
        Firebase.getAllRetailers((res) => {
          const wgRetailers = Object.values(res);
          Firebase.getAllNCRetailers((res) => {
            const ncRetailers = Object.values(res);
            const retailers = [...wgRetailers, ...ncRetailers];
            setAllRetailers(retailers);

            let retailerOptions = retailers
              .filter(
                (obj) =>
                  (obj.territory || TerritoryOptions[0]) === brandTerritory
              )
              .filter((retailer) => retailer.ecopayRetailer)
              .sort((a, b) => a.retailerName.localeCompare(b.retailerName))
              .map((obj) => ({
                label: obj.retailerName,
                value: obj.retailerID,
              }));
            setRetailers(retailerOptions);
          });
        });
      });
    }
  }, [brand]);
  useEffect(() => {
    onChangeContent(perkContent);
  }, [perkContent]);
  const handleOnChangePerk = (perk) => {
    setPerkContent({ ...perkContent, ...perk });
  };
  const handleSelectRetailer = (retailer) => {
    setSelectedRetailer(retailer);
    setPerkContent({
      ...perkContent,
      perkName: retailer.label,
      perkLogo: allRetailers.find((r) => r.retailerID === retailer.value).logo,
    });
  };
  const handleChangeGrabber = ({ target }) => {
    setPerkContent({ ...perkContent, attentionGrabber: target.value });
  };
  const handleSelectHotTopic = (topic) => {
    setPerkContent({
      ...perkContent,
      hotTopic: topic.value ? topic.value.id : null,
    });
  };
  return (
    <div
      className={`${!isVisible ? "d-none" : ""} mt-3`}
      style={{ textAlign: "left", width: "100%" }}
    >
      {offerType === "perk" ? (
        <AddPerkForm onChange={handleOnChangePerk} />
      ) : (
        <React.Fragment>
          <h5 className="section-title">Select a TokenPay Retailer</h5>
          <Select
            value={selectedRetailer}
            onChange={handleSelectRetailer}
            options={[{ label: "None", value: null }, ...retailerOptions]}
            placeholder="Select a TokenPay Retailer"
          ></Select>
        </React.Fragment>
      )}
      <React.Fragment>
        <h5 className="section-title">Add an attention grabber</h5>
        <textarea
          name="attentionGrabber"
          className="form-control form-control-md mb-2"
          placeholder="Type your content here..."
          onChange={handleChangeGrabber}
          value={perkContent.attentionGrabber}
          maxLength="360"
        />
        <p className="bottom-small-text">Max characters: 360</p>
      </React.Fragment>
      {/* <React.Fragment>
        <h5 className="section-title">Select a hot topic</h5>
        <Select
          isSearchable={true}
          value={
            hot_topic_tags.find(
              (item) => item.value.id === perkContent.hotTopic
            ) || { label: "None", value: null }
          }
          onChange={handleSelectHotTopic}
          options={[{ label: "None", value: null }, ...hot_topic_tags]}
          placeholder="Select a hot topic tag"
        ></Select>
      </React.Fragment> */}
    </div>
  );
};
export default OfferContent;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/OfferContent.js